import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState('somnambulistui', ['orderId']),
    ...mapGetters('somnambulistui', ['getBlobPermissions', 'getBlob', 'getCurrentStep', 'isCustomOrder', 'getLangString'])
  },
  methods: {
    ...mapMutations('somnambulistui', ['SET_ORDER_COMPLETED'])
  }
}
